import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';

import VideoIcon from 'app/assets/icons/video-tutorial.svg?react';

export default function NavigationHelp() {
  const { navigationHelp } = useSelector(({ header }) => header);

  if (!navigationHelp) return null;

  return (
    <Box
      className="px-12 py-10 flex items-center gap-8 cursor-pointer"
      onClick={navigationHelp.callback}
    >
      <Typography className="font-600 text-12 text-typography-primary">
        {navigationHelp.title}
      </Typography>
      {navigationHelp.type === 'video' && <VideoIcon className="flex-none h-16" />}
    </Box>
  );
}
